

const SUPABASE_URL="https://twmlumnnpvfilegvoixe.supabase.co"
const SUPABASE_ANON_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3bWx1bW5ucHZmaWxlZ3ZvaXhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0MDM3MDQsImV4cCI6MjA2MDk3OTcwNH0.2r6aQFrEcps2b_aIKL_Ez4RN7VDCkEh4q0TpWNkyL00"


// Environment configuration
export const config = {
    supabase: {
      url: SUPABASE_URL,
      anonKey: SUPABASE_ANON_KEY,
    }
  };